import {
  AccountDetailsEventTypesEnum,
  AccountDetailsTrackingEvent,
} from '../../../../../../../src/components/accounts/tracking/accountDetailsTrackingHelpers';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../../../../../src/services/tracking';
import {
  buildContactsManagerAccountCopyLinkPayload,
  buildContactsManagerAccountDeletePayload,
  buildContactsManagerAccountEditPayload,
  buildContactsManagerAccountViewPayload,
} from './trackingHelpers';

export function accountsManagerAccountDetailsTrackingHandler(event: AccountDetailsTrackingEvent) {
  switch (event.type) {
    case AccountDetailsEventTypesEnum.VIEW: {
      trackInterfaceEvent(
        InterfaceEventsEnum.CONTACTS_MANAGER_ACCOUNT_VIEW,
        buildContactsManagerAccountViewPayload(event.accountId, event?.accountLocation),
      );
      break;
    }
    case AccountDetailsEventTypesEnum.EDIT: {
      trackInterfaceEvent(
        InterfaceEventsEnum.CONTACTS_MANAGER_ACCOUNT_EDIT,
        buildContactsManagerAccountEditPayload(event.accountId, event.action, event.attribute),
      );
      break;
    }
    case AccountDetailsEventTypesEnum.COPY_LINK: {
      trackInterfaceEvent(
        InterfaceEventsEnum.CONTACTS_MANAGER_ACCOUNT_COPY_LINK,
        buildContactsManagerAccountCopyLinkPayload(event.accountId),
      );
      break;
    }
    case AccountDetailsEventTypesEnum.DELETE: {
      trackInterfaceEvent(
        InterfaceEventsEnum.CONTACTS_MANAGER_ACCOUNT_DELETE,
        buildContactsManagerAccountDeletePayload(event.accountId),
      );
      break;
    }
    default:
    // Do not track anything
  }
}
